<template>
<div>
    <ul class="socialEffect__box">
        <li>
            <a class="socialEffect__link" href="https://www.youtube.com/channel/UCiSfMiEnihaQbom4dhIZBpQ" @click='clickData("youtube")'> 
                <i class="fab fa-youtube"></i>
            </a>
        </li>
        <li>
            <a class="socialEffect__link" href="https://www.instagram.com/noelrecords_apps/"  @click='clickData("instagram")'>
                <i class="fab fa-instagram"></i>
            </a>
        </li>
        <li>
            <a class="socialEffect__link" href="https://twitter.com/NoelRecords_App"  @click='clickData("twitter")'>
                <i class="fab fa-twitter"></i>
            </a>
        </li>
      </ul>
</div>
</template>

<script>
import firebase from "firebase";
export default {
  name: 'socialBar',
  props: [],
  methods:{
    clickData:function(name){
      firebase.analytics().logEvent(name);
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.socialEffect__link {
  margin: .3em;
  display: block;
  width: 60px;
  /* height: 60px; */
  line-height: 60px;
  border-radius: 50%;
  text-align: center;
  position: relative;
  z-index: 1;
  /* color: #bfbfbf; */
  font-size: 1.6rem;
  /* background: rgba(255, 255, 255, 0.1); */
  /* transition: transform ease-out 0.2s; */
}

.socialEffect__box {
  background-color: white;
  height:50px; 
}


.socialEffect__box li {
  display: inline-block;
}

.fa-instagram {
  display: inline-block;
  color: black;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  z-index: -1;
}

.fab.fa-youtube {
  display: inline-block;
  color: red;
    position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  z-index: -1;
}

.fab.fa-twitter {
  display: inline-block;
  color: #00b0ed;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  z-index: -1;
}
  

</style>